import { Component, ViewChild, OnInit, Renderer2 } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IonicPage, NavController, NavParams, ViewController, Content } from 'ionic-angular';
import { cloneDeep, groupBy } from 'lodash';

import { TabsServiceProvider } from '../../providers/tabs-service/tabs-service';
import { CoffeService } from '../../interfaces/CoffeService.interface';
import { CoffeShopService } from '../../providers/coffe-shop/coffe-shop.service';

@IonicPage()
@Component({
  selector: 'page-coffe-shop-service',
  templateUrl: 'coffe-shop-service.html',
})
export class CoffeShopServicePage implements OnInit {
  @ViewChild(Content) content: Content;
  public coffeService: CoffeService = null;
  public categoryName: string = '';
  public special_instructions = new FormControl(['']);

  public sizes: CoffeService[] = [];
  public services: { name: string | null, services: CoffeService[], view: 'kind' | 'box' | 'inline' }[] = [];

  private bottom_margin: any;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private tabsService: TabsServiceProvider,
    private viewCtrl: ViewController,
    public coffeShopService: CoffeShopService,
    private render: Renderer2
  ) {
    this.categoryName = cloneDeep(navParams.get('categoryName'));
    this.coffeService = cloneDeep(navParams.get('service'));

    if (this.coffeService.size) {
      this.sizes = this.coffeService.children.filter((service: CoffeService) => service.service_type === 1 && service.size);
      this.sizes = this.sizes.map((size: CoffeService) => {
        if (!size.image_url) {
          size.image_url = this.coffeService.image_url;
        };

        return size;
      })
      const local_coffe_service: CoffeService = cloneDeep(this.coffeService);
      delete local_coffe_service.children;
      local_coffe_service.selected = true;
      local_coffe_service.service_type = 1;
      local_coffe_service.price = this.coffeService.price;
      local_coffe_service.calculated_price = 0;
      local_coffe_service.quantity = 0;
      local_coffe_service.default_size_type = true;
      this.sizes.unshift(local_coffe_service);
    };

    const local_services = cloneDeep(this.coffeService.children.filter((service: CoffeService) => service.service_type !== 1));
    const groupdChildren = groupBy(local_services, 'name');
    for (let field in groupdChildren) {
      const view = groupdChildren[field].some((service: CoffeService) => service.kind) ? 'kind' :
        groupdChildren[field].some((service: CoffeService) => !service.kind && service.image_url) ? 'box' : 'inline';
      this.services.push({ name: field, services: groupdChildren[field], view });
    }
    this.services.sort((a, b) => +b.services.every((service: CoffeService) => !!service.kind) - +a.services.every((service: CoffeService) => !!service.kind));
  }
  ionViewCanEnter() {
    this.tabsService.hide();
  }
  ngOnInit() {
    window.addEventListener('keyboardWillShow', (event: any) => {
      this.bottom_margin = (this.content._scrollContent.nativeElement as HTMLElement).style.marginBottom || (this.content._fixedContent.nativeElement as HTMLElement).style.marginBottom;
      this.render.setStyle(this.content._scrollContent.nativeElement, 'margin-bottom', `${event.keyboardHeight}px`);
      this.render.setStyle(this.content._fixedContent.nativeElement, 'margin-bottom', `${event.keyboardHeight}px`);
      setTimeout(() => { if (this.content) this.content.scrollToBottom() }, 0);
    });
    window.addEventListener('keyboardWillHide', () => {
      this.render.setStyle(this.content._scrollContent.nativeElement, 'margin-bottom', this.bottom_margin);
      this.render.setStyle(this.content._fixedContent.nativeElement, 'margin-bottom', this.bottom_margin);
    });
  }
  calculateDopping(children: CoffeService, type: 'plus' | 'minus') {
    // const children_index = this.doppings.no_images.findIndex((service_children: CoffeService) => children.id === service_children.id);
    if (type === 'minus' && children.quantity > 0) {
      children.quantity -= 1;
    }
    if (type === 'plus') {
      children.quantity += 1;
    }
    children.selected = children.quantity > 0;
    children.calculated_price = children.quantity === 0 ? 0 : children.price * children.quantity;

  }
  public selectSize(size: CoffeService, index: number): void {
    this.sizes = this.sizes.map((size: CoffeService) => {
      size.selected = false;
      return size;
    });
    size.selected = true;
    size.quantity = 1;
  }
  public selectBoxItem(item: CoffeService, index: number): void {
    item.selected = !item.selected;
    item.quantity = 1;
  }

  public goToCoffeShop(): void {
    const doppings = [];
    if (this.sizes.length) {
      const size = cloneDeep(this.sizes.find((size: CoffeService) => size.selected));
      size.default_size_type ? size.price = 0 : null;
      doppings.push(size);
    }

    this.services.forEach((service: { name: string | null, services: CoffeService[], view: 'kind' | 'box' | 'inline' }) => {
      const selected_services = service.services.filter((serv: CoffeService) => serv.selected);
      if (selected_services && selected_services.length) {
        // selected_services[0].quantity = selected_services.length;
        doppings.push(...selected_services);
      }
    });
    this.coffeService.quantity = 1;
    this.coffeService.doppings = cloneDeep(doppings);
    this.viewCtrl.dismiss({ service: this.coffeService });
  }
  closeModal() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/coffe-shop-service/coffe-shop-service.ts